export default {
  defaultStyles: {
    fontFamily:
      '-apple-system, BlinkMacSystemFont, Roboto, "Segoe UI", Helvetica,Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol" !important',
    fontSize: "14px",
    lineHeight: "20px",
    fontWeight: "400",
    boxSizing: "content-box !important",
    width: "unset",
    "& ::-webkit-scrollbar": { width: "0 !important" },
    "& div": {
      boxSizing: "content-box",
    },
    "& *": {
      maxWidth: "unset",
    },
    "& p": {
      margin: "unset",
      fontSize: "unset",
      padding: "unset",
      color: "unset",
      fontFamily:
        '-apple-system, BlinkMacSystemFont, Roboto, "Segoe UI", Helvetica,Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol" !important',
      fontWeight: "400",
      lineHeight: "unset",
      textIndent: "unset",
    },
    "& a": {
      textDecoration: "unset",
    },
    "& strong": {
      margin: "unset",
      fontSize: "unset",
      padding: "unset",
      color: "unset",
      fontFamily:
        '-apple-system, BlinkMacSystemFont, Roboto, "Segoe UI", Helvetica,Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol" !important',
      fontWeight: "700",
      lineHeight: "unset",
    },
    "& h3": {
      margin: "unset",
      fontFamily: "unset",
      textTransform: "unset",
    },
    "& h3:first-child": {
      margin: "unset",
    },
    "& textarea": {
      fontFamily:
        '-apple-system, BlinkMacSystemFont, Roboto, "Segoe UI", Roboto,Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji","Segoe UI Symbol" !important',
      fontSize: "14px",
      fontWeight: "400",
      minHeight: "initial",
      boxShadow: "none",
      "&:focus": { boxShadow: "none", outline: "none" },
    },
    "& button": {
      padding: "0",
      maxWidth: "unset",
      borderStyle: "solid",
      cursor: "pointer",
      minHeight: "auto",
      lineHeight: "initial",
      boxShadow: "unset",
      fontSize: "unset",
      fontWeight: "unset",
      height: "unset",
      letterSpacing: "unset",
      textTransform: "unset",
      textDecoration: "unset",
      "&:hover": {
        color: "white",
      },
      fontFamily:
        '-apple-system, BlinkMacSystemFont, Roboto, "Segoe UI", Roboto,Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji","Segoe UI Symbol" !important',
    },
    textAlign: "left",
    "& li": {
      listStyle: "unset",
      margin: "unset",
      fontSize: "unset",
      fontWeight: "unset",
      padding: "unset",
      fontFamily:
        '-apple-system, BlinkMacSystemFont, Roboto, "Segoe UI", Roboto,Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji","Segoe UI Symbol" !important',
    },
    "& li::before": { content: "unset" },
    "& ul": {
      listStyle: "unset",
      margin: "unset",
      fontSize: "unset",
      fontWeight: "unset",
      padding: "unset",
      paddingInlineStart: "40px",
      fontFamily:
        '-apple-system, BlinkMacSystemFont, Roboto, "Segoe UI", Roboto,Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji","Segoe UI Symbol" !important',
      color: "unset",
    },
  },
};
